import { render, staticRenderFns } from "./reservation-view.vue?vue&type=template&id=6257ce72&scoped=true&"
import script from "./reservation-view.vue?vue&type=script&lang=js&"
export * from "./reservation-view.vue?vue&type=script&lang=js&"
import style0 from "./reservation-view.vue?vue&type=style&index=0&id=6257ce72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6257ce72",
  null
  
)

export default component.exports